import * as LDClient from "launchdarkly-js-client-sdk";
import { Singleton } from 'app/utils';
import { $Constants, $CurrentUser, Company } from 'app/classes';


export class LaunchDarklyService {
    public ldclient: any = null;
    public initalized: boolean = false;
    public userFeatures: any = { webChannelDisplay: false, intercomIntegration: false };
    public init() {
        var ldPromise = new Promise((resolve, reject) => {
            try {
                this.ldclient = LDClient.initialize($Constants.launchdarkly, { 'anonymous': true });
                this.ldclient.on('ready', () => {
                    this.initalized = true;
                });
                this.ldclient.on('change', (settings) => {
                    if (settings) {
                        this.userFeatures = {
                            webChannelDisplay: settings['web-channel-notification'].current || false,
                            intercomIntegration: settings['intercom-integration'].current || false
                        };
                    }
                });
                resolve({ ready: true })
            } catch (e) {
                reject({ ready: false, error: e });
            }
        });
        return ldPromise;

    }
    public updateUser(user) {
        return new Promise((resolve, reject) => {
            if (!user.id) {
                reject({ error: 'no user id' });
            }
            const ldUser = {
                key: user.id,
                firstName: user.name.first,
                lastName: user.name.last,
                email: user.email,
                anonymous: false,
                avatar: user.avatar_image_url,
                bootstrap: {
                    'web-channel-notification': false,
                    'intercom-integration': false
                },
                custom: {
                    organizationId: user.company.id,
                    organizationName: user.company.name,
                    user_type: user.user_type
                }
            };
            try {

                this.ldclient.identify(ldUser, null, () => {
                    this.userFeatures = {
                        webChannelDisplay: this.ldclient.variation('web-channel-notification', false),
                        intercomIntegration: this.ldclient.variation('intercom-integration', false)
                    };
                    this.initalized = true;
                });
            } catch (e) {
                return ({ ready: false, error: e });
            }

        });
    }
    public logoutUser() {
        this.ldclient.identity({ anonymous: true }, null);
    }
}
export let $LaunchDarklyService = Singleton('$LaunchDarklyService', LaunchDarklyService);
